import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import {
  CreationTestTabs,
  CreationTestTextModal,
  DashboardImportSuccessTitle,
  ErrorPredPreviewText,
  ErrorPredPreviewTitle,
  ErrorPublishText,
  ErrorPublishTitle,
} from 'src/config/config';
import { Text } from '@consta/uikit/Text';
import { Bread } from '../../components/Bread';
import { Button } from '@consta/uikit/Button';
import { useHistory, useParams } from 'react-router-dom';
import { Tabs } from '@consta/uikit/Tabs';
import { IconClose } from '@consta/uikit/IconClose';

// Styles
import cn from 'classnames/bind';
import styles from './styles.styl';
import { IconBackward } from '@consta/uikit/IconBackward';
import { IconAdd } from '@consta/uikit/IconAdd';
import TestForm from 'src/components/TestForm';
import {
  InformerStatusTitleEnum,
  LocalStorageKeysEnum,
  StatusInformerEnum,
  SurveyStatusEnum,
  SurveyTypeEnum,
  TabsTestParameter,
  TitleTestEnum,
} from 'src/utils/enum';
import { PrivateRoutesEnum } from 'src/utils/router';
import { ThunkDispatch } from 'redux-thunk';
import { State } from 'src/redux/reducer';
import { Action } from 'redux';
import { clearTestData } from 'src/redux/features/surveys/testData/actions';
import { EditCreateSurveys } from 'src/redux/features/surveys/editSurveys/types';
import { loadEditSurveys } from 'src/redux/features/surveys/editSurveys/actions';
import {
  testDataAllSelector,
  testDataLoadedSelector,
} from 'src/redux/features/surveys/testData/selectors';
import { TestState } from 'src/redux/features/surveys/testData/types';
import {
  editSurveysLoadedSelector,
  editSurveysPendingSelector,
} from 'src/redux/features/surveys/editSurveys/selectors';
import { Modal } from '@consta/uikit/Modal';
import { CloseModal } from 'src/components/CloseModal';
import QuestionCreation from 'src/components/QuestionCreation';
import QuestionContent from 'src/components/QuestionContent';
import { allListQuestionIdSelector } from 'src/redux/features/questions/allListQuestions/selectors';
import { AllListQuestionDataEnt } from 'src/redux/features/questions/allListQuestions/types';
import { ErrorPublishModal } from 'src/components/ErrorPublishModal';
import {
  changeStatusSurveyIdle,
  loadChangeSurveyStatus,
} from 'src/redux/features/surveys/changeSurveyStatus/actions';
import {
  changeStatusSurveyLoadedSelector,
  changeStatusSurveyPendingSelector,
  changeStatusSurveySelector,
} from 'src/redux/features/surveys/changeSurveyStatus/selectors';
import { addImagesIdle } from 'src/redux/features/surveys/addImages/actions';
import { PublishSurveyData } from 'src/redux/features/surveys/changeSurveyStatus/types';
import { loadOneSurvey } from 'src/redux/features/surveys/oneSurvey/actions';
import {
  oneSurveyLoadedSelector,
  oneSurveySelector,
  shouldLoadOneSurveySelector,
} from 'src/redux/features/surveys/oneSurvey/selectors';
import { Loader } from '@consta/uikit/Loader';
import { loadSortedQuestion } from 'src/redux/features/questions/sortedQuestion/actions';
import { SortedAnswersData } from 'src/redux/features/questions/sortedQuestion/types';
import { titleCreateTestSelector } from 'src/redux/features/surveys/titleCreateTest/selectors';
import { TitleCreateTestType } from 'src/redux/features/surveys/titleCreateTest/types';
import { breadCreateTest } from 'src/utils';
import { Badge } from '@consta/uikit/Badge';
import { ISurvey } from 'src/redux/features/surveys/allSurvey/types';
import {
  deleteSurveyIdle,
  loadDeleteSurvey,
} from 'src/redux/features/surveys/deleteSurvey/actions';
import { deleteSurveyLoadedSelector } from 'src/redux/features/surveys/deleteSurvey/selectors';
import { Informer } from '@consta/uikit/Informer';
import { StatusInformerType } from 'src/utils/types';
import { IconThumbUp } from '@consta/uikit/IconThumbUp';
import { importSurveysLoadedSelector } from 'src/redux/features/surveys/importSurveys/selectors';
import { importSurveysIdle } from 'src/redux/features/surveys/importSurveys/actions';

const cx = cn.bind(styles);

export interface ICreationTestParams {
  id: string;
}

export interface CreationTestProps {
  loadOneSurvey: (id: number) => void;
  setTestDataId: (id: number) => void;
  clearTestData: () => void;
  isEditLoaded: boolean;
  isEditPending: boolean;
  loadEditSurveys: (editSurveys: EditCreateSurveys, id: number) => void;
  testData: TestState;
  allListQuestion: AllListQuestionDataEnt[];
  loadChangeSurveyStatus: (id: number, status: number) => void;
  isLoadingChangeStatus: boolean;
  changeStatusSurveyIdle: () => void;
  addImagesIdle: () => void;
  isPendingChangeStatus: boolean;
  changeStatus: PublishSurveyData;
  isShouldOneSurvey: boolean;
  isLoadedOneSurvey: boolean;
  isLoadedTestData: boolean;
  loadSortedQuestion: (id: number, data: SortedAnswersData) => void;
  titleCreateTest: TitleCreateTestType;
  oneSurvey: ISurvey;
  deleteSurvey?: (id: number) => void;
  deleteSurveyIdle: () => void;
  isLoadingDelete: boolean;
  isImportSurveyLoaded: boolean;
  importSurveysIdle: () => void;
}

const CreationTest: React.FC<CreationTestProps> = ({
  loadOneSurvey,
  loadEditSurveys,
  testData,
  isEditLoaded,
  clearTestData,
  isEditPending,
  allListQuestion,
  loadChangeSurveyStatus,
  isLoadingChangeStatus,
  changeStatusSurveyIdle,
  addImagesIdle,
  isPendingChangeStatus,
  changeStatus,
  isShouldOneSurvey,
  isLoadedOneSurvey,
  isLoadedTestData,
  loadSortedQuestion,
  titleCreateTest,
  oneSurvey,
  deleteSurvey,
  deleteSurveyIdle,
  isLoadingDelete,
  isImportSurveyLoaded,
  importSurveysIdle,
}) => {
  const history = useHistory();

  const { id } = useParams<ICreationTestParams>();

  const [activeTabs, setActiveTabs] = useState(CreationTestTabs[0]);
  const [isQuestion, setQuestion] = useState(false);
  const [editQuestion, setEditQuestion] = useState(null);
  const [isSave, setSave] = useState(false);
  const [modalCLose, setModalCLose] = useState(false);
  const [modalErrorPublish, setModalErrorPublish] = useState(false);
  const [dataModalPublish, setDataModalPublish] = useState({
    title: '',
    text: '',
  });
  const [listQuestion, setListQuestion] = useState([]);

  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  const [isOpen, setIsOpen] = useState(false);
  const [title, setTitle] = useState('');
  const [text, setText] = useState('');
  const [timerId, setTimerId] = useState<NodeJS.Timeout>();
  const [statusInformer, setStatusInformer] = useState<StatusInformerType>(
    StatusInformerEnum.Success,
  );

  useEffect(() => {
    isEditLoaded && setSave(false);
  }, [isEditLoaded]);

  useEffect(() => {
    if (isLoadingDelete) {
      history.push(PrivateRoutesEnum.DASHBOARD);
      deleteSurveyIdle();
    }
  }, [deleteSurveyIdle, history, isLoadingDelete]);

  useEffect(() => {
    if (isShouldOneSurvey) {
      loadOneSurvey(Number(id));
    }
  }, [id, isShouldOneSurvey, loadOneSurvey]);

  useEffect(() => {
    if (isLoadingChangeStatus) {
      changeStatusSurveyIdle();
      if (oneSurvey.status === SurveyStatusEnum.DRAFT) {
        localStorage.setItem(LocalStorageKeysEnum.PUBLISH_URL, oneSurvey.hash);
        localStorage.setItem(
          LocalStorageKeysEnum.TELEGRAM_BOT_LINK,
          String(oneSurvey?.telegram_bot_link),
        );
        history.push(PrivateRoutesEnum.PUBLISH_TEST);
      } else if (oneSurvey.status === SurveyStatusEnum.PUBLISHED) {
        history.push(PrivateRoutesEnum.DASHBOARD);
      }
    }
  }, [
    changeStatus,
    changeStatusSurveyIdle,
    history,
    isEditLoaded,
    isLoadingChangeStatus,
    oneSurvey,
  ]);

  const handleSave = useCallback(() => {
    const data = {
      name: testData.name || '',
      type: testData.type,
      welcome_page_header: testData.welcome_page_header || '',
      welcome_page_description: testData.welcome_page_description || '',
      final_page_header: testData.final_page_header || '',
      final_page_description: testData.final_page_description || '',
      tags: testData.tags?.map((item) => item.name) || [],
      passing_score:
        testData.type === SurveyTypeEnum.SURVEY
          ? 0
          : testData?.passing_score || 0,
      is_show_answers: testData.is_show_answers,
      is_show_points: testData.is_show_points,
      cron_started_at: testData.cron_started_at
        ? new Date(testData.cron_started_at)
        : null,
      cron_finished_at: testData.cron_finished_at
        ? new Date(testData.cron_finished_at)
        : null,
      type_counter: testData.type_counter,
    };
    if (allListQuestion.length > 1) {
      const questionIds = { questions: listQuestion.map((item) => item.id) };
      loadSortedQuestion(Number(id), questionIds);
    }

    loadEditSurveys(data, Number(id));
  }, [
    testData,
    allListQuestion.length,
    loadEditSurveys,
    listQuestion,
    loadSortedQuestion,
    id,
  ]);

  const handleBack = useCallback(() => {
    if (isQuestion) {
      setQuestion(false);
    } else if (isSave) {
      setModalCLose(true);
    } else {
      history.push(PrivateRoutesEnum.DASHBOARD);
    }
  }, [history, isQuestion, isSave]);

  const handleСlose = useCallback(() => {
    clearTestData();
    history.push(PrivateRoutesEnum.DASHBOARD);
  }, [clearTestData, history]);

  const handlePublish = useCallback(() => {
    if (
      !(
        testData.name &&
        testData.welcome_page_header &&
        testData.welcome_page_description &&
        testData.final_page_header &&
        testData.final_page_description &&
        allListQuestion.length > 0
      )
    ) {
      setDataModalPublish({ title: ErrorPublishTitle, text: ErrorPublishText });
      setModalErrorPublish(true);
    } else {
      loadChangeSurveyStatus(Number(id), SurveyStatusEnum.PUBLISHED);
    }
  }, [allListQuestion, loadChangeSurveyStatus, testData, id]);

  const handlePredPreview = useCallback(() => {
    if (
      !(
        testData.name &&
        ((testData.welcome_page_header &&
          testData.welcome_page_description &&
          testData.final_page_header &&
          testData.final_page_description) ||
          testData.status !== SurveyStatusEnum.DRAFT) &&
        allListQuestion.length > 0
      )
    ) {
      setModalErrorPublish(true);
      setDataModalPublish({
        title: ErrorPredPreviewTitle,
        text: ErrorPredPreviewText,
      });
    } else {
      window.open(`/walkthrough/${oneSurvey.hash}/preview`);
    }
  }, [allListQuestion, testData, oneSurvey]);

  const handleEnd = useCallback(() => {
    loadChangeSurveyStatus(Number(id), SurveyStatusEnum.ENDED);
  }, [loadChangeSurveyStatus, id]);

  const handleDeleteSurv = useCallback(() => {
    deleteSurvey(oneSurvey.id);
  }, [deleteSurvey, oneSurvey]);

  const surveyName = useMemo(() => {
    if (isImportSurveyLoaded) return DashboardImportSuccessTitle;
    return '';
  }, [isImportSurveyLoaded]);

  const informerText: string = useMemo(() => {
    if (isImportSurveyLoaded)
      return InformerStatusTitleEnum.IMPORT_SURVEY_SUCCESS;
    return '';
  }, [isImportSurveyLoaded]);

  useEffect(() => {
    if (isImportSurveyLoaded) {
      setStatusInformer(StatusInformerEnum.Success);
      setTitle(surveyName);
      setText(informerText);
      setIsOpen(true);

      if (timerId) clearTimeout(timerId);
      setTimerId(
        setTimeout(() => {
          setIsOpen(false);
        }, 5000),
      );
    }

    if (isImportSurveyLoaded) importSurveysIdle();
    return () => {
      clearTimeout(timerId);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [importSurveysIdle, isImportSurveyLoaded]);

  if (!isLoadedOneSurvey || !isLoadedTestData) return <Loader />;
  return (
    <div className={cx('CreationTest')}>
      <div className={cx('CreationTest__headerRow')}>
        <div className={cx('CreationTest__container')}>
          <Button
            onClick={() => handleBack()}
            size="s"
            view="clear"
            iconRight={IconBackward}
            onlyIcon
          />
          <Text
            className={cx('CreationTest__header')}
            weight="semibold"
            size="xl"
          >
            {titleCreateTest.name}
          </Text>
          {titleCreateTest.id === TitleTestEnum.Edit && (
            <div className={cx('SurveyItem__status')}>
              {oneSurvey?.status === SurveyStatusEnum.DRAFT && (
                <Badge label="ЧЕРНОВИК" status="system" />
              )}
              {oneSurvey?.status === SurveyStatusEnum.PUBLISHED && (
                <Badge label="ОПУБЛИКОВАН" status="normal" />
              )}
              {oneSurvey?.status === SurveyStatusEnum.ENDED && (
                <Badge label="ЗАВЕРШЕН" status="success" />
              )}
            </div>
          )}
        </div>
        {oneSurvey.status !== SurveyStatusEnum.ENDED && !isQuestion && (
          <Button
            onClick={() => {
              setActiveTabs(CreationTestTabs[1]);
              setQuestion(true);
              addImagesIdle();
              setEditQuestion(null);
            }}
            size="m"
            view="clear"
            iconLeft={IconAdd}
            label="Добавить вопрос"
          />
        )}
      </div>
      <Bread
        className={cx('CreationTest__bread')}
        setLinkProps={setQuestion}
        breads={breadCreateTest(isQuestion, titleCreateTest)}
      />
      {!isQuestion && (
        <Tabs
          className={cx('CreationTest__tabs', {
            CreationTest__tabs_cont:
              activeTabs.id === TabsTestParameter.Content,
          })}
          value={activeTabs}
          onChange={({ value }) => setActiveTabs(value)}
          items={CreationTestTabs}
          getLabel={(item) => item.name}
          view="bordered"
          size="m"
        />
      )}
      {activeTabs.id === TabsTestParameter.Setting && (
        <div>
          <TestForm
            allListQuestion={allListQuestion}
            testData={testData}
            setSave={setSave}
            oneSurvey={oneSurvey}
            titleCreateTest={titleCreateTest}
          />
          <Button
            onClick={() => setActiveTabs(CreationTestTabs[1])}
            label={'Перейти к вопросам'}
            size="m"
            className={cx('CreationTest__question')}
          />
        </div>
      )}
      {activeTabs.id === TabsTestParameter.Content && (
        <div>
          {isQuestion ? (
            <QuestionCreation
              editQuestion={editQuestion}
              setQuestion={setQuestion}
              testData={testData}
              oneSurvey={oneSurvey}
              titleCreateTest={titleCreateTest}
              id={id}
            />
          ) : (
            <QuestionContent
              setEditQuestion={setEditQuestion}
              setQuestion={setQuestion}
              listQuestion={listQuestion}
              setListQuestion={setListQuestion}
              setSave={setSave}
              testData={testData}
              oneSurvey={oneSurvey}
              titleCreateTest={titleCreateTest}
              id={id}
            />
          )}
        </div>
      )}
      {(!isQuestion || activeTabs.id === TabsTestParameter.Setting) && (
        <div className={cx('CreationTest__footer')}>
          {isSave && (
            <Text
              view="secondary"
              size="m"
              className={cx('CreationTest__saveFooter')}
            >
              {'Есть несохраненные изменения'}
            </Text>
          )}
          <Button
            onClick={() => handleBack()}
            size="m"
            view="secondary"
            label="Закрыть"
            className={cx('CreationTest__close')}
          />
          <Button
            onClick={() => handlePredPreview()}
            size="m"
            view="secondary"
            label="Предпросмотр"
            className={cx('CreationTest__close')}
          />
          {isSave ? (
            <Button
              onClick={() => handleSave()}
              size="m"
              view="primary"
              label="Сохранить"
              loading={isEditPending}
              className={cx('CreationTest__close')}
            />
          ) : (
            <>
              {oneSurvey.status === SurveyStatusEnum.DRAFT && (
                <Button
                  onClick={() => handlePublish()}
                  size="m"
                  view="primary"
                  loading={isPendingChangeStatus}
                  label="Опубликовать"
                  className={cx('CreationTest__close')}
                />
              )}
              {oneSurvey.status === SurveyStatusEnum.PUBLISHED && (
                <Button
                  onClick={() => handleEnd()}
                  size="m"
                  view="primary"
                  loading={isPendingChangeStatus}
                  label="Завершить"
                  className={cx('CreationTest__close')}
                />
              )}
              {oneSurvey.status === SurveyStatusEnum.ENDED && (
                <Button
                  onClick={() => setDeleteModalOpen(true)}
                  size="m"
                  view="primary"
                  loading={isPendingChangeStatus}
                  label="Удалить"
                  className={cx('CreationTest__delete')}
                />
              )}
            </>
          )}
        </div>
      )}
      <Modal isOpen={modalCLose} hasOverlay>
        <CloseModal
          title={'Закрыть страницу'}
          text={CreationTestTextModal}
          textButton={'Подтвердить'}
          iconClose={IconClose}
          handleClick={handleСlose}
          setModalOpenBlocking={setModalCLose}
        />
      </Modal>
      <Modal isOpen={modalErrorPublish} hasOverlay>
        <ErrorPublishModal
          testData={testData}
          allListQuestion={allListQuestion?.length || 0}
          setModalErrorPublish={setModalErrorPublish}
          title={dataModalPublish.title}
          text={dataModalPublish.text}
        />
      </Modal>
      <Modal isOpen={deleteModalOpen}>
        <CloseModal
          iconClose={IconClose}
          setModalOpenBlocking={setDeleteModalOpen}
          handleClick={() => handleDeleteSurv()}
          title="Удаление опроса"
          text="Вы уверены, что хотите удалить опрос?"
          textButton="Удалить"
        />
      </Modal>
      {isOpen && (
        <div className={cx('CreationTest__informer')}>
          <Informer
            status={statusInformer}
            size="s"
            title={title}
            label={text}
            onClick={() => {
              setIsOpen(false);
              if (timerId) clearTimeout(timerId);
            }}
            icon={IconThumbUp}
          />
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state: State, props: any) => ({
  allListQuestion: allListQuestionIdSelector(state),
  isEditLoaded: editSurveysLoadedSelector(state, props),
  isEditPending: editSurveysPendingSelector(state),
  testData: testDataAllSelector(state),
  isLoadingChangeStatus: changeStatusSurveyLoadedSelector(state, props),
  isPendingChangeStatus: changeStatusSurveyPendingSelector(state),
  changeStatus: changeStatusSurveySelector(state),
  isShouldOneSurvey: shouldLoadOneSurveySelector(state),
  isLoadedOneSurvey: oneSurveyLoadedSelector(state, props),
  isLoadedTestData: testDataLoadedSelector(state, props),
  titleCreateTest: titleCreateTestSelector(state),
  oneSurvey: oneSurveySelector(state),
  isLoadingDelete: deleteSurveyLoadedSelector(state, props),
  isImportSurveyLoaded: importSurveysLoadedSelector(state, props),
});

const mapDispatchToProps = (dispatch: ThunkDispatch<State, void, Action>) => ({
  loadOneSurvey: (id: number) => dispatch(loadOneSurvey(id)),
  loadEditSurveys: (editSurveys: EditCreateSurveys, id: number) =>
    dispatch(loadEditSurveys(editSurveys, id)),
  clearTestData: () => dispatch(clearTestData()),
  loadChangeSurveyStatus: (id: number, status: number) =>
    dispatch(loadChangeSurveyStatus(id, status)),
  changeStatusSurveyIdle: () => dispatch(changeStatusSurveyIdle()),
  addImagesIdle: () => dispatch(addImagesIdle()),
  loadSortedQuestion: (id: number, data: SortedAnswersData) =>
    dispatch(loadSortedQuestion(id, data)),
  deleteSurvey: (id: number) => dispatch(loadDeleteSurvey(id)),
  deleteSurveyIdle: () => dispatch(deleteSurveyIdle()),
  importSurveysIdle: () => dispatch(importSurveysIdle()),
});

export default connect(mapStateToProps, mapDispatchToProps)(CreationTest);
